let btnNext = document.querySelector('.card__arrow--right');
let btnPrev = document.querySelector('.card__arrow--left');
let gridElem = document.querySelector('.card__gridwrap');
let left = 0;
let getWrap = document.querySelector('.card_wrapper');
if (gridElem) {
  btnPrev.addEventListener('click', function () { // slide left
    left = left + 210;
    if (left > 250) {
      left = 0;
    }
    gridElem.style.left = left + 'px';
  });
  btnNext.addEventListener('click', function () { // slide right
    left = left - 210;
    if (left < -1200) {
      left = 0;
    }
    gridElem.style.left = left + 'px';
  });
}
